import Title from "@components/global/new/Title/Title";
import styles from "./EditAccount.module.scss";
import classNames from "classnames";
import Icon from "@components/global/new/Icon/Icon";
import Field from "@components/global/new/Field/Field";
import WithModal from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import Button from "@components/global/new/Button/Button";
import { useEditAccountControl } from "./useEditAccountControl";
import { EditAccountPropsI } from "./EditAccount.props";
import Image from "@components/global/new/Image/Image";
import Error from "@components/global/new/Error/Error";
import Loader from "@components/global/Loader/Loader";
import Switch from "react-switch";
import Checkbox from "@components/global/new/Checkbox/Checkbox";
import cn from "classnames";

import photo from "@assets/icons/photo.svg";

function EditAccount({
  user,
  update,
  formatMessage,
  ...props
}: EditAccountPropsI) {
  if (!user) return null;
  const control = useEditAccountControl(user, update);

  return (
    <div className={styles.wrapper}>
      <Title>{formatMessage({ id: "modal.edit_account.title" })}</Title>
      <form className={styles.content} onSubmit={control.onSave}>
        <div className={styles.add_photo}>
          <Image src={control.userImage} />
          <label htmlFor='upload-photo' className={styles.photo}>
            {/* <input type='file' /> */}
            <Icon src={photo} />
            <div className={styles.upload}>
              <span>
                {formatMessage({ id: "modal.edit_account.app_photo" })}
              </span>
              <input
                type='file'
                onChange={(e) =>
                  e.target.files && control.getImageUrl(e.target.files[0])
                }
                id='upload-photo'
                accept='image/jpeg,image/png,image/gif,image/jpg,image/webp'
              />
            </div>
          </label>
        </div>

        <div className={styles.main}>
          <div className={styles.name_wrapper}>
            <Field
              id='name'
              name={formatMessage({ id: "modal.edit_account.name" })}
              placeholder='Hame'
              type='text'
              defaultValue={user.name}
            />
            <div className={classNames(styles.twoFa_switcher)}>
              <span
                className={cn({
                  [styles.active]: control.twoFa,
                })}
              >
                {formatMessage({ id: "modal.edit_account.2fa_text" })}
              </span>
              <Switch
                onChange={control.onChangeTwoFa}
                checked={control.twoFa}
                onColor='#002AFF'
                height={15}
                width={30}
                offColor={"#BDCAD5"}
              />
            </div>
          </div>
          <div className={styles.private}>
            <Field
              id={`email`}
              name={formatMessage({ id: "modal.edit_account.email" })}
              placeholder={`Email`}
              type='email'
              defaultValue={user.email.value}
            />
            <div className={classNames(styles.switcher)}>
              <span
                className={cn({
                  [styles.active]: !control.privateEmail,
                })}
              >
                {formatMessage({ id: "modal.edit_account.public" })}
              </span>
              <Switch
                onChange={() => control.setPrivateEmail(!control.privateEmail)}
                checked={control.privateEmail}
                onColor='#002AFF'
                height={15}
                width={30}
                offColor={"#BDCAD5"}
              />
              <span
                className={cn({
                  [styles.active]: control.privateEmail,
                })}
              >
                {formatMessage({ id: "modal.edit_account.private" })}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.additional}>
          <Field
            id='password'
            name={formatMessage({ id: "modal.edit_account.new_password" })}
            type='password'
            isError={!!control.changePassErr}
          />
          <Field
            id='repeat_password'
            name={formatMessage({ id: "modal.edit_account.repeat_password" })}
            type='password'
            isError={!!control.changePassErr}
          />

          {control.changePassErr && <Error errors={control.changePassErr} />}

          <div className={styles.private}>
            <Field
              id='telegram_username'
              name={formatMessage({ id: "modal.edit_account.telegram" })}
              placeholder='Telegram username'
              type='text'
              defaultValue={user.telegram.value}
            />
            <div
              className={classNames(styles.switcher, {
                [styles.active]: control.privateTelegram,
              })}
            >
              <span
                className={cn({
                  [styles.active]: !control.privateTelegram,
                })}
              >
                {formatMessage({ id: "modal.edit_account.public" })}
              </span>
              <Switch
                onChange={() =>
                  control.setPrivateTelegram(!control.privateTelegram)
                }
                checked={control.privateTelegram}
                onColor='#002AFF'
                height={15}
                width={30}
                offColor={"#BDCAD5"}
              />
              <span
                className={cn({
                  [styles.active]: control.privateTelegram,
                })}
              >
                {formatMessage({ id: "modal.edit_account.private" })}
              </span>
            </div>
          </div>

          <div className={styles.textarea}>
            <label>{formatMessage({ id: "modal.edit_account.about" })}</label>
            <textarea placeholder='text' id='about' defaultValue={user.about} />
          </div>

          <div className={styles.summary}>
            <label>
              {formatMessage({ id: "modal.edit_account.summary.title" })}
            </label>
            <div>
              <Checkbox
                checked={control.summaryEmail}
                text={formatMessage({ id: "modal.edit_account.summary.email" })}
                onClick={() => control.setSummaryEmail(!control.summaryEmail)}
              />
              <Checkbox
                checked={control.summaryTelegram}
                text={formatMessage({
                  id: "modal.edit_account.summary.telegrams",
                })}
                onClick={() =>
                  control.setSummaryTelegram(!control.summaryTelegram)
                }
              />
            </div>
          </div>
          <Field
            id='entered_password'
            name={formatMessage({ id: "modal.edit_account.password" })}
            type='password'
            isError={!!control.errors}
            className={styles.current_password}
          />

          {control.errors && <Error errors={control.errors} />}

          <Button type='submit'>
            {formatMessage({ id: "modal.edit_account.save" })}
          </Button>
        </div>
      </form>
      {control.isLoading && <Loader />}
    </div>
  );
}

export default WithModal(MODALS_ENUM.EDIT_ACCOUNT, EditAccount);
